<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="400"
    >
      <v-card>
        <v-card-title>
          {{ $t('Upload media') }}
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="form.title"
            :loading="form.processing"
            :disabled="form.processing"
            :error-messages="errors.title"
            :label="$t('Title')"
            outlined
            autofocus
          />

          <v-file-input
            v-model="form.file"
            :loading="form.processing"
            :disabled="form.processing"
            :error-messages="errors.file"
            :label="$t('Select a file')"
            outlined
            accept="image/*, application/pdf"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click.native="cancel"
          >
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="form.processing"
            :loading="form.processing"
            @click="submit"
          >
            {{ $t('Upload') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      errors: {
        type: Object,
        default: () => ({}),
      }
    },

    data() {
      return {
        dialog: true,
        form: this.$inertia.form('CreateMedia', {
          title: '',
          file: null
        })
      }
    },

    methods: {
      submit() {
        this.form.post(this.route('media.store').toString(), {
          onSuccess: () => this.form.reset(),
          preserveState: true
        });
      },

      cancel() {
        return this.$inertia.visit(this.route('media.index'), {
          preserveState: true
        });
      }
    }
  }
</script>
